import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicy = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="container">
          <Link to="/" onClick={scrollToTop} className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-updated">Last Updated: January 2025</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              trademarkIcontext ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our trademark registration services.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Register for our services</li>
              <li>Fill out contact forms</li>
              <li>Subscribe to our newsletter</li>
              <li>Communicate with us via email or phone</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name and business name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Mailing address</li>
              <li>Trademark details and business information</li>
              <li>Payment information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and manage our trademark registration services</li>
              <li>Process your trademark applications with the USPTO</li>
              <li>Communicate with you about your application status</li>
              <li>Send you important updates and notifications</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Improve our services and website functionality</li>
              <li>Comply with legal obligations and protect our legal rights</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
            <ul>
              <li><strong>USPTO:</strong> We share necessary information to file and process your trademark application</li>
              <li><strong>Service Providers:</strong> Trusted third parties who assist us in operating our business (e.g., payment processors, email service providers)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications</li>
              <li>Withdraw consent where we rely on your consent to process your information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to enhance your experience on our website, analyze usage patterns, and improve our services. You can control cookies through your browser settings.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review their privacy policies.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> info@trademarkincontext.com</li>
              <li><strong>Phone:</strong> +1 (123) 123-4567</li>
              <li><strong>Address:</strong> 12100 Wilshire Blvd 8th floor, Los Angeles, CA 90025</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
